module.exports = __webpack_public_path__ + "img/anti-oxidant.2e341d20.webp";